import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DocumentUtilisateurModel } from 'src/models/profil-utilisateur/document-utilisateur-model';
import { UtilisateurService } from './utilisateur.service';
import { DocumentData } from 'src/models/profil-utilisateur/document-data';
import { map, Observable } from 'rxjs';
import { ParametreUtilisateurModel } from 'src/models/profil-utilisateur/parametre-utilisateur-model';

@Injectable({
  providedIn: 'root'
})
export class ProfilUtilisateurService {
  private baseUrl = environment.api_LMS + 'ProfilUtilisateur';

  constructor(private http: HttpClient) { }

  uploadDocument(documentData: DocumentData): Observable<any> {
    const formData = new FormData();
    if (documentData.utilisateurId) {
      formData.append('utilisateurId', documentData.utilisateurId.toString());
      formData.append('createurId', documentData.createurId.toString());
    }

    if (documentData.file) {
      formData.append('file', documentData.file!, documentData.file!.name);
    }
    if (documentData.nomFichier) {
      formData.append('nomFichier', documentData.nomFichier);
    }
    if (documentData.description) {
      formData.append('description', documentData.description);
    }
    if (documentData.extension) {
      formData.append('extension', documentData.extension);
    }
    if (documentData.estVisible) {
      formData.append('estVisible', documentData.estVisible.toString());
    }

    return this.http.post<any>(
      `${this.baseUrl}/UploadDocument`,
      formData
    );
  }

  obtenirDocumentUtilisateur(utilisateurId: number, estAdminOuPilote: boolean): Observable<DocumentUtilisateurModel[]> {
    return this.http.get<DocumentUtilisateurModel[]>(`${this.baseUrl}/ObtenirDocumentUtilisateur`, { params: { utilisateurId: utilisateurId, estAdminOuPilote: estAdminOuPilote } });
  }

  obtenirParametreUtilisateur(utilisateurId: number): Observable<ParametreUtilisateurModel> {
    return this.http.get<ParametreUtilisateurModel>(`${this.baseUrl}/ObtenirParametre`, { params: { utilisateurId: utilisateurId } });
  }


  obtenirDocument(documentId: number): Observable<{ blob: Blob, contentType: string | null }> {
    return this.http.get(`${this.baseUrl}/obtenirDocument`, {
      params: { documentId: documentId },
      observe: 'response',
      responseType: 'blob'
    }).pipe(
      map((response: HttpResponse<Blob>) => {
        const contentType = response.headers.get('Content-Type');
        return { blob: response.body!, contentType };
      })
    );
  }
}
